module.exports = __webpack_public_path__ + "img/Custom_Dashboard_Image.0aec8f2d.svg";